module.exports = __webpack_public_path__ + "img/puzzle4.jpg";